import React, { useState } from "react";
import { Modal, Button, Group, Text, Box, ActionIcon, Tooltip } from "@mantine/core";
import { IconDownload, IconX, IconArrowsMinimize, IconArrowsMaximize } from "@tabler/icons-react";

interface IModalPrevisualizarPDFProps {
    abierto: boolean;
    cerrar: () => void;
    urlPDF: string;
    nombreArchivo: string;
    descargarPDF: () => void;
}

const ModalPrevisualizarPDF: React.FC<IModalPrevisualizarPDFProps> = ({
    abierto,
    cerrar,
    urlPDF,
    nombreArchivo,
    descargarPDF
}) => {
    const [pantallaCompleta, setPantallaCompleta] = useState(false);

    const togglePantallaCompleta = () => {
        setPantallaCompleta(!pantallaCompleta);
    };

    return (
        <Modal
            opened={abierto}
            onClose={cerrar}
            title={
                <Group justify="space-between" style={{ width: '100%' }}>
                    <Text fw={600} size="md">
                        Previsualización: {nombreArchivo}
                    </Text>
                    <Tooltip label={pantallaCompleta ? "Salir de pantalla completa" : "Pantalla completa"} withArrow>
                        <ActionIcon
                            variant="subtle"
                            color="primary"
                            size="lg"
                            onClick={togglePantallaCompleta}
                        >
                             {pantallaCompleta ? <IconArrowsMinimize size={18} /> : <IconArrowsMaximize size={18} />}
                        </ActionIcon>
                    </Tooltip>
                </Group>
            }
            size={pantallaCompleta ? "100%" : "xl"}
            centered={false}
            fullScreen={pantallaCompleta}
            padding={pantallaCompleta ? "md" : "md"}
            zIndex={pantallaCompleta ? 10000 : 200}
            styles={{
                inner: {
                    paddingTop: pantallaCompleta ? '0' : '120px',
                    paddingBottom: pantallaCompleta ? '0' : '20px'
                },
                body: {
                    height: pantallaCompleta ? 'calc(100vh - 80px)' : 'auto',
                    display: 'flex',
                    flexDirection: 'column'
                }
            }}
        >
            <Box style={{ 
                display: 'flex', 
                flexDirection: 'column', 
                height: '100%',
                gap: '1rem'
            }}>
                <object
                    data={`${urlPDF}#toolbar=1&navpanes=0&scrollbar=1`}
                    type="application/pdf"
                    style={{
                        width: "100%",
                        height: pantallaCompleta ? "calc(100vh - 160px)" : "65vh",
                        minHeight: "500px",
                        border: "1px solid #e0e0e0",
                        borderRadius: "4px",
                        flex: pantallaCompleta ? 1 : 'none'
                    }}
                    title={nombreArchivo}
                >
                    <p>Su navegador no puede mostrar PDFs. 
                        <Button 
                            variant="link" 
                            onClick={descargarPDF}
                            style={{ padding: 0, height: 'auto', marginLeft: '5px' }}
                        >
                            Haga clic aquí para descargar
                        </Button>
                    </p>
                </object>
                <Group justify="flex-end" gap="sm">
                    <Button
                        variant="light"
                        color="primary"
                        leftSection={<IconX size={16} />}
                        onClick={cerrar}
                    >
                        Cerrar
                    </Button>
                    <Button
                        variant="filled"
                        color="primary"
                        leftSection={<IconDownload size={16} />}
                        onClick={descargarPDF}
                    >
                        Descargar
                    </Button>
                </Group>
            </Box>
        </Modal>
    );
};

export default ModalPrevisualizarPDF;
